
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { ExternalUser } from '@/models/externalUser';
import { externalUserWebservice } from '@/webservices/externalUser';
import type { Project } from '@/models/project';
import Divider from '@/components/layout/Divider.vue';

@Component({
    name: 'UpdateExternalUser',
    components: { Divider },
})
export default class UpdateExternalUser extends Vue {
    private isModalActive: boolean = false;
    private errors: string[] = [];
    private externalUserData: ExternalUser = {} as ExternalUser;

    @Prop() private project: Project;
    @Prop({
        type: Object,
        default: () => {
            return {
                id: 0,
                firstname: '',
                lastname: '',
                email: '',
                tenant: '',
                selected: false,
                project_id: 0,
                company_id: 0,
            };
        },
    })
    private externalUser: ExternalUser;

    private mounted() {
        this.externalUserData = JSON.parse(JSON.stringify(this.externalUser));
        this.externalUserData.project_id = this.project.id;
    }

    private openModal() {
        this.isModalActive = true;
        this.externalUserData = JSON.parse(JSON.stringify(this.externalUser));
        this.externalUserData.project_id = this.project.id;
    }

    private closeModal() {
        this.isModalActive = false;
        this.errors = [];
    }

    private checkError(errorKey: string) {
        return this.errors.includes(errorKey);
    }

    private store() {
        if (!this.verification()) {
            return;
        }

        console.log('foo', this.externalUserData);
        externalUserWebservice
            .store(this.externalUserData)
            .then((res) => {
                this.$emit('reload', res);
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.update.externalUser').toString(),
                    type: 'is-success',
                });
                this.closeModal();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private verification(): boolean {
        this.externalUserData.email = this.externalUserData.email.trim();
        this.externalUserData.firstname = this.externalUserData.firstname.trim();
        this.externalUserData.lastname = this.externalUserData.lastname.trim();

        this.errors = [];

        if (!this.externalUserData.tenant && !this.externalUserData.firstname && !this.externalUserData.lastname) {
            this.errors.push('name');
        }

        if (!this.externalUserData.email || !this.validateEmail(this.externalUserData.email)) {
            this.errors.push('email');
        }

        return this.errors.length === 0;
    }

    private validateEmail(email: string) {
        // tslint:disable-next-line:max-line-length
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }
}
